import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import BASE_URL from "../config"; // ✅ Import BASE_URL

const EditPayment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  
  const client_id = queryParams.get("id");
  const payment_id = queryParams.get("payment_id");

  const [formData, setFormData] = useState({
    last_payment_date: "",
    next_due_date: "",
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch payment details
  useEffect(() => {
    const fetchPaymentDetails = async () => {
      if (!payment_id) {
        setError("Payment ID not found in URL");
        setLoading(false);
        return;
      }

      try {
        console.log(`Fetching: ${BASE_URL}api/payment/find-one/${payment_id}`); // ✅ Use BASE_URL
        const response = await axios.get(`${BASE_URL}api/payment/find-one/${payment_id}`); // ✅ Use BASE_URL

        console.log("Full API Response:", response.data); // Debugging

        if (response.data) {
          setFormData({
            last_payment_date: response.data.last_payment_date
              ? response.data.last_payment_date.split("T")[0]
              : "",
            next_due_date: response.data.next_due_date
              ? response.data.next_due_date.split("T")[0]
              : "",
          });
        } else {
          setError("Payment data not found in API response");
        }
      } catch (error) {
        console.error("Error fetching payment data:", error);
        setError("Failed to fetch payment data.");
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentDetails();
  }, [payment_id]);

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      console.log(`Updating: ${BASE_URL}api/payment/update/${payment_id}`); // ✅ Use BASE_URL

      const response = await axios.put(`${BASE_URL}api/payment/update/${payment_id}`, { // ✅ Use BASE_URL
        last_payment_date: formData.last_payment_date,
        next_due_date: formData.next_due_date,
      });

      console.log("Update Response:", response.data);

      if (response.data.message === "Payment updated successfully") {
        Swal.fire({
          icon: "success",
          title: "Updated!",
          text: "Payment updated successfully.",
          timer: 2000,
          showConfirmButton: false,
        }).then(() => {
          navigate("/clients");
        });
      }
    } catch (error) {
      console.error("Error updating payment:", error);
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: "An error occurred while updating the payment.",
      });
    }
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-3">Edit Payment</h2>

      {loading ? (
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : error ? (
        <div className="alert alert-danger">{error}</div>
      ) : (
        <form onSubmit={handleSubmit} className="p-3 border rounded">
          <div className="mb-3">
            <label className="form-label">Last Payment Date</label>
            <input
              type="date"
              name="last_payment_date"
              value={formData.last_payment_date}
              onChange={handleChange}
              className="form-control w-50"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Next Due Date</label>
            <input
              type="date"
              name="next_due_date"
              value={formData.next_due_date}
              onChange={handleChange}
              className="form-control w-50"
              required
            />
          </div>

          <button type="submit" className="btn btn-success">Update Payment</button>
          <a href="/clients" className="btn btn-secondary ms-2">Cancel</a>
        </form>
      )}
    </div>
  );
};

export default EditPayment;
